$(document).on 'turbo:load', ->
  $('[data-toggle="tooltip"], a[rel=tooltip]').tooltip()
